import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import "react-toastify/dist/ReactToastify.css"

import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import { ToastContainer } from 'react-toastify';

import { Foot } from './components/footC/foot'
import { home } from './components/homeC/home';
import { servicios } from './components/serviciosC/servicios';
import { Contacto } from './components/contactoC/contacto';
import { TMessage } from './components/topMessage/tMessage'




ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>

    <TMessage></TMessage>

      <Switch>
        <Route exact path="/" component={home} />
        <Route path="/servicios" component={servicios} />
        <Route path="/contacto" component={Contacto} />
      </Switch>

      <Route path='/instagram' component={() => { 
        window.location.href = 'https://www.instagram.com/comercial_amaro/?hl=es'; 
        return null;
      }}/>

      <ToastContainer></ToastContainer>
      <Foot></Foot>
    
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
